import { ColumnViewModel } from '../../shared/column-types';

export const CHEMICALS_GDA_SUMMARY: ColumnViewModel = {
  columns: [
    'evidenceTimeline',
    'chemPrefName',
    'chemID',
    'geneSymbol',
    'geneDescription',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'numDiseasesAssociatedToGene',
    'numDBSNPsupportingAssociation',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'score',
    'sourceScore',
    'numberPmidsWithChemsIncludedInEvidence',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numVariantsAssociatedToGene',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
    'geneEnsemblIDs',
    'geneNcbiType',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'pathwayName',
    'pathwayID',
  ],
  defaultVisible: [
    'evidenceTimeline',
    'geneSymbol',
    'geneDescription',
    'diseaseName',
    'score',
    'numDiseasesAssociatedToGene',
    'numGenesAssociatedToDisease',
    'sourceScore',
    'numberPmidsWithChemsIncludedInEvidence',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numVariantsAssociatedToGene',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'diseaseType',
    'diseaseClassName_MSH',
  ],
};